import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Checkout from "./component";
import {
    setMaxStep,
    getTradeInDetails,
    customerOptedTrade,
    getTradeInState,
    handleRejectModal,
    getOrderDetails,
    getSeoContent,
    setUserUpdating
} from "./actions";
import withLogin from "../../../../components/au.desktop/with-login";
import withGuestLogin from "../guest-login";
import { logout, setLoginType } from "../../../../components/au.configuration/actions";

const mapStateToProps = ({
    auc2bTradein: { maxStep, tradeInData, tradeinOpted },
    user: { secureToken, isLoggedIn, isGuestLogin, isFetched },
    deliveryInfo
}) => ({
    maxStep,
    secureToken,
    tradeInData,
    tradeinOpted,
    deliveryInfo,
    isLoggedIn,
    isGuestLogin,
    isFetched
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setMaxStepConnect: setMaxStep,
            getTradeInDetailsConnect: getTradeInDetails,
            customerOptedTradeConnect: customerOptedTrade,
            getTradeInStateConnect: getTradeInState,
            handleRejectModalConnect: handleRejectModal,
            getOrderDetailsConnect: getOrderDetails,
            getSeoContentConnect: getSeoContent,
            setUserUpdatingConnect: setUserUpdating,
            setLoginTypeConnect: setLoginType,
            logoutConnect: logout
        },
        dispatch
    );

export default withGuestLogin(withLogin(withRouter(connect(mapStateToProps, mapDispatchToProps)(Checkout))));
